import { Component, input } from '@angular/core';

@Component({
    selector: 'info-box',
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
    standalone: false
})
export class InfoBoxComponent {
    public type = input<'info' | 'info-light' | 'warning' | 'error' | 'neutral' | 'error-dark'>('neutral');

    public mode = input<'simple' | 'complex'>('simple');

    public padding = input<10 | 16 | 24>(16);

    public marginBottom = input<string>();
}
